import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Input, } from '../../../Shared/index';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface ClassCodeLinkProps {
  next: (event) => void;
  back: (event) => void;
  showSnackbar: (event) => void;
  classroom: any;
}

export const ClassCodeLink = ({ next, back, showSnackbar, classroom }: ClassCodeLinkProps) => {
  const link = `quill.org/join/${classroom.code}`

  function handleShowSnackbar() {
    showSnackbar('Class code link copied')
  }

  return (
    <div className="create-a-class-modal-content">
      <div className="create-a-class-modal-body modal-body">
        <h3 className="title">Share the class code link with your students</h3>
        <div className="copy-class-code-container">
          <p className="class-code-link">{link}</p>
          <CopyToClipboard onCopy={handleShowSnackbar} text={link}>
            <button className="quill-button medium green outlined focus-on-light">Copy</button>
          </CopyToClipboard>
        </div>
      </div>
      <div className="create-a-class-modal-footer">
        <div className="buttons-container">
          <button className="quill-button medium green outlined focus-on-light" onClick={back}>Back</button>
          <DemoGuardedButton className="quill-button medium green contained focus-on-light" onClick={next}>Next</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ClassCodeLink
